module.exports = __webpack_public_path__ + "static/media/checkbox_s.4a2648b2.svg";